import { Injectable } from '@angular/core';
import {HubService} from '../services/hub.service';
import {SignalRHttpClient} from '../services/signal-r-http-client';
import {TranslateService} from '../translate/translate.service';
import {ControlledInputs} from '../../units/models/controlled-inputs';
import {HubConnectionState, ISubscription} from '@microsoft/signalr';
import { UnitsFacade } from '../../stores/units/facades/units.facade';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';
import { ModalService } from '../services/modal.service';
import { SocketsManagerService } from '../../sockets-manager/services';
import { CoreFacade } from 'src/app/stores/core/facades/core.facade';

@Injectable({
  providedIn: 'root'
})
export class ControlledInputsHubService extends HubService {
  private subscription: ISubscription<any>;
  constructor(
    protected signalRHttpClient: SignalRHttpClient,
    protected modalService: ModalService,
    protected translate: TranslateService,
    private unitsFacade: UnitsFacade,
    protected authFacade: AuthFacade,
    protected socketsManagerService: SocketsManagerService,
    protected _coreFacade: CoreFacade
  ) {
    super('hubs/controlledInputs', modalService, translate, signalRHttpClient, authFacade, socketsManagerService, _coreFacade);
  }


  public getStreamFor(unitIds: number[]) {
    if (this.hubConnection?.state !== HubConnectionState.Connected) {
      return;
    }
    this.subscription = this.hubConnection.stream('ControlledInputs', unitIds).subscribe({
      next: (data: ControlledInputs[]) => {
        if (data && Array.isArray(data)) {
          this.unitsFacade.wsControlledInputUpdateSuccess(data);
        }
      },
      complete: () => {},
      error: (err) => {},
    });
  }

  public closeStream() {
    if (this.subscription) {
      this.subscription.dispose();
    }
  }

  protected onDisconnect() {
    this.closeStream();
  }
}
